module.exports = __webpack_public_path__ + "img/no-photo-1.1646f686.png";